module.exports = __webpack_public_path__ + "static/media/Lens-Sweet_TW.a70c6ee9.png";